const BlankPage = {
  name: 'BlankPage',
  template: '<div></div>',
};

export default BlankPage;
